import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { PolicyCondition } from "./conditions";

export const PolicySubscription = Type.Object({
  type: Type.Literal("email"),
  destination: Type.Array(Type.String()),
});

export const BasePolicy = Type.Object({
  id: Type.String(),
  name: Type.String(),
  description: Type.Optional(Type.String()),
  enabled: Type.Boolean(),
  shouldAttachMsgContent: Type.Optional(Type.Boolean()),
  severity: Type.Optional(Type.Number()),
  conditions: Type.Array(PolicyCondition),
  subscriptions: Type.Array(PolicySubscription),
  createdAt: Type.Optional(Type.String()),
  updatedAt: Type.Optional(Type.String()),
});

export type BasePolicy = TypeBoxToType<typeof BasePolicy>;
export type PolicySubscription = TypeBoxToType<typeof PolicySubscription>;
